<p-panel>
    <ng-template pTemplate="header">
        <div><h4>Diaries</h4></div>
        <div class="flex flex-auto justify-content-end gap-2">
            <p-button icon="pi pi-plus" label="New" [text]="true" (onClick)="newDiaryOp.toggle($event)"></p-button>
            <p-button *ngIf="!showClosed" icon="pi pi-filter-slash" label="Show Closed" [text]="true" (onClick)="showClosed = true"></p-button>
            <p-button *ngIf="showClosed" icon="pi pi-filter" label="Show Open" [text]="true" (onClick)="showClosed = false"></p-button>

            <p-overlayPanel appendTo="body" #newDiaryOp [style]="{width: '85vw', height:'85vh'}" styleClass="overflow-y-scroll">
                <app-diary-editor (saved)="addDiary($event); newDiaryOp.hide()" (cancelled)="newDiaryOp.hide()"></app-diary-editor>
            </p-overlayPanel>
        </div>
    </ng-template>
    <div class="flex flex-column overflow-y-scroll">

        <p-table [value]="sortedDiaries" [paginator]="sortedDiaries.length > 5" [rows]="5">
            <ng-template pTemplate="header">
                <tr>
                    <th>Task</th>
                    <th>Status</th>
                    <th>Assigned To</th>
                    <th>{{ showClosed ? 'Closed' : 'Due' }}</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-diary>
                <tr>
                    <td>{{diary.subject}}</td>
                    <td>
                        <p-tag *ngIf="diary.assignedTo == null && diary.closedDate == null && diary.createdBy.id !== systemUserId" 
                        severity="success" icon="pi pi-star-fill" [rounded]="true" value="New" />
                        <p-tag
                            *ngIf="diary.assignedTo != null && diary.dueDate != null && diary.closedDate == null && diary.createdBy.id === systemUserId"
                            [style]="{'background-color':'#8b5cf6','color':'#ffffff'}" icon="pi pi-cog" [rounded]="true" value="System" />
                        <p-tag
                            *ngIf="diary.assignedTo != null && diary.dueDate != null && diary.closedDate == null && isDueToday(diary.dueDate) && diary.createdBy.id !== systemUserId"
                            [style]="{'background-color':'#00009f','color':'#ffffff'}" icon="pi pi-clock" [rounded]="true" value="Today" />
                        <p-tag
                            *ngIf="diary.assignedTo != null && diary.dueDate != null && diary.closedDate == null && !isDueToday(diary.dueDate) && now <= diary.dueDate && diary.createdBy.id !== systemUserId"
                            [style]="{'background-color':'#009f00','color':'#ffffff'}" icon="pi pi-user" [rounded]="true" value="Active" />
                        <p-tag
                            *ngIf="diary.assignedTo != null && diary.dueDate != null && diary.closedDate == null && !isDueToday(diary.dueDate) && now > diary.dueDate && diary.createdBy.id !== systemUserId"
                            severity="danger" icon="pi pi-exclamation-triangle" [rounded]="true" value="Overdue" />
                        <p-tag *ngIf="diary.closedDate != null" severity="secondary" icon="pi pi-check" [rounded]="true" value="Closed" />
                    </td>
                    <td>{{diary.assignedTo?.fullName}}</td>
                    <td>{{(showClosed ? diary.closedDate : diary.dueDate) | date : 'shortDate' }}</td>
                    <td>
                        <p-button icon="pi pi-eye" [text]="true" pTooltip="View diary" tooltipPosition="top"
                            (onClick)="viewDiary = diary; viewDiaryVisible = true"></p-button>
                        <p-button icon="pi pi-check" [text]="true" pTooltip="Close diary" tooltipPosition="top"
                            (onClick)="closeDiary(diary)"
                            [disabled]="diary.closedDate"></p-button>
                        <p-button icon="pi pi-user" [text]="true" pTooltip="Reassign diary" tooltipPosition="top"
                            (onClick)="assignDiaryOp.toggle($event)"
                            [disabled]="!diary.createdBy || diary.createdBy.id === systemUserId || diary.closedDate"></p-button>
                        <p-overlayPanel appendTo="body" #assignDiaryOp>
                            <div>
                                <div class="flex pt-3 grid">
                                    <div class="field col-5">
                                        <p-floatLabel>
                                            <p-calendar #selectedDueDate [ngModel]="diary.dueDate" id="dueDate" [style]="{'width':'100%'}"></p-calendar>
                                            <label for="dueDate">Due Date</label>
                                        </p-floatLabel>
                                    </div>
                                    <div class="col-5 field">
                                        <p-dropdown #selectedAssignee dataKey="id" [ngModel]="diary.assignedTo" [options]="(activeUsers$ | async) ?? []" optionLabel="fullName" [style]="{'width':'100%'}"></p-dropdown>
                                    </div>
                                    <div class="col-2">
                                        <p-button icon="pi pi-check" [disabled]="selectedDueDate.value == null || selectedAssignee.value == null || selectedDueDate.value < now" (onClick)="assignDiary(diary,selectedAssignee.value,selectedDueDate.value)"></p-button>
                                    </div>
                                </div>
                            </div>
                        </p-overlayPanel>
                    </td>
                </tr>
            </ng-template>

        </p-table>

    </div>
</p-panel>

<p-dialog
    [modal]="true"
    appendTo="body"
    [(visible)]="viewDiaryVisible"
    [maximizable]="true"
    styleClass="custom-diary-dialog"
    [style]="{width: '85vw', height: '85vh'}"
    [contentStyle]="{'overflow-y': 'auto', 'height': 'calc(100% - 1rem)'}">
    <ng-template pTemplate="header">
        <span><strong>Subject:</strong> {{viewDiary?.subject}}</span>
    </ng-template>
    <div *ngIf="viewDiary" class="flex flex-column gap-3">
        <div class="grid">
            <div class="col-3"><strong>Assigned To:</strong> {{viewDiary.assignedTo?.fullName ?? '—'}}</div>
            <div class="col-3"><strong>Due:</strong> {{viewDiary.dueDate | date : 'medium'}}</div>
            <div class="col-3"><strong>Created:</strong> {{viewDiary.createdDate | date : 'medium'}} by {{viewDiary.createdBy?.fullName}}</div>
        </div>
        <div class="grid" *ngIf="viewDiary.closedDate">
            <div class="col-6"><strong>Closed:</strong> {{viewDiary.closedDate | date : 'medium'}}</div>
        </div>
        <p-divider></p-divider>
        <div class="diary-body" [innerHtml]="viewDiary.body"></div>
    </div>
</p-dialog>
